import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ScraperProgressDialogService {
  constructor(private http: HttpClient) {}

  public getCompanyNames(studyId: number, comparableIds: number[]): Observable<any> {
    return this.http.post<Record<number, string>>('/api/Study/GetCompanyNames', { studyId: studyId, comparableIds: comparableIds });
  }
}
